import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Hexagon from './Hexagon.js';
const AssociationIcon = styled(Hexagon) `
  transform: rotate(-90deg);
  color: ${THEME.COLOR_ACCENT};
  flex-shrink: 0;
`;
export default AssociationIcon;
//# sourceMappingURL=AssociationIcon.js.map